module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-1-photo-5-f86c71ae736234c00e21f49d71821084.webp";